import { BaseModel } from "sjs-base-model";

export default class SkillModel extends BaseModel {
  public readonly name: string = "";
  public readonly slug: string = "";

  constructor(data: Partial<SkillModel>) {
    super();

    this.update(data);
  }
}
